// Angular
import { inject, Injectable } from '@angular/core';

// NgRx
import { Actions, createEffect, ofType } from '@ngrx/effects';

// PrimeNG
import { MessageService } from 'primeng/api';

// RxJS
import { tap } from 'rxjs/operators';

// Acciones internas
import * as UiActions from './ui.actions';

@Injectable()
export class UiEffects {
  private actions$ = inject(Actions);
  private messageService = inject(MessageService);

  showMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UiActions.showMessage),
        tap(({ message }) => {
          this.messageService.add(message);
        })
      ),
    { dispatch: false }
  );
}
